/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Input, ModalHeader, ModalBody, ModalFooter, Button, Select, SelectItem, Divider, Chip, Tooltip } from '@nextui-org/react';
import { useSelector } from 'react-redux';
import { IconEye, IconEyeOff, IconTrash } from '@tabler/icons-react';
import toast from 'react-hot-toast';
import { Constants, fromPhotos, getOnlyNumbers } from '../../../utils';
import { IconImageEdit } from '../../../assets/icons';
import { UsersService, SchoolService } from '../../../services';
import CountryFlag from '../../../components/country-flag';

const ModalCreateTeacher = ({ user, onSuccess, onClose }) => {
  const { countries, dniTypes, form, onChange, onSubmit, phoneCodes, subjects, grades, subjectsSelected, onRemoveGrade, onRemoveSubject, schoolYears } = useForm(user);
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => setIsVisible(!isVisible);

  const submit = async () => {
    const isSuccess = await onSubmit();
    if (isSuccess) onSuccess();
  }

  const visibilityBtn = (
    <button className="focus:outline-none" type="button" onClick={toggleVisibility}>
      {isVisible ? (
        <IconEyeOff className="w-6 h-6" />
      ) : (
        <IconEye className="w-6 h-6" />
      )}
    </button>
  )

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">{!!user ? 'Editar' : 'Nuevo'}</ModalHeader>
      <ModalBody className="gap-8 px-0">
        <div className="flex items-center justify-start px-6">
          <label htmlFor="photo" className="cursor-pointer text-center border-2 border-gray w-16 h-16 rounded-lg flex justify-center items-center self-center overflow-hidden">
            {!!form.photoUrl ? (
              <img className="w-full h-full object-cover" src={form.photoUrl} alt="Foto" />
            ) : (
              <img className="w-12 object-contain opacity-50" src={IconImageEdit} alt="Foto" />
            )}
            <input
              id="photo"
              type="file"
              accept="image/*"
              hidden
              onChange={e => onChange(e.target.files[0], 'photo')}
            />
          </label>

          <div className="flex flex-col ml-4 text-sm">
            <span className="font-medium leading-3">Subir foto de perfil</span>
            <span>(Tipo carnet y fondo gris)</span>
          </div>
        </div>

        <div className="flex flex-col flex-1 gap-4">
          <div className="grid grid-cols-3 gap-4 px-6">
            <Input
              label="Nombre"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form.name}
              onValueChange={v => onChange(v, 'name')}
            />
            <Input
              label="Apellido"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form.lastname}
              onValueChange={v => onChange(v, 'lastname')}
            />
            <Input
              label="Teléfono"
              labelPlacement="outside"
              placeholder=" "
              startContent={(
                <Select
                  aria-label="Código de área"
                  variant="flat"
                  classNames={{ trigger: 'border-0 max-w-28' }}
                  disallowEmptySelection={true}
                  selectedKeys={(!!form.phonecode_id && !!phoneCodes.length) ? [form.phonecode_id] : []}
                  onSelectionChange={v => onChange(v.currentKey, 'phonecode_id')}
                  startContent={<CountryFlag phoneCodeId={form.phonecode_id} phoneCodes={phoneCodes} />}
                >
                  {phoneCodes.map((item) => (
                    <SelectItem
                      key={item.value}
                      value={item.value}
                      startContent={<CountryFlag src={item.url} />}
                      classNames={{ title: 'min-w-48' }}
                    >
                      {item.label}
                    </SelectItem>
                  ))}
                </Select>
              )}
              variant="bordered"
              radius="sm"
              classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
              value={form.phone}
              onValueChange={v => onChange(getOnlyNumbers(v), 'phone')}
            />
          </div>

          <div className="grid grid-cols-3 gap-4 px-6">
            <Input
              label="Correo electrónico"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form.email}
              onValueChange={v => onChange(v, 'email')}
            />
            <Input
              label="N° de DNI/C.I"
              labelPlacement="outside"
              placeholder=" "
              startContent={(
                <Select
                  aria-label="Tipo de documento"
                  variant="flat"
                  classNames={{ trigger: 'border-0 max-w-24' }}
                  disallowEmptySelection={true}
                  selectedKeys={(!!form.document_type_id && !!dniTypes.length) ? [form.document_type_id] : []}
                  onSelectionChange={v => onChange(v.currentKey, 'document_type_id')}
                >
                  {dniTypes.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.label}
                    </SelectItem>
                  ))}
                </Select>
              )}
              variant="bordered"
              radius="sm"
              classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
              value={form.document}
              onValueChange={v => onChange(getOnlyNumbers(v), 'document')}
            />
            <Select
              label="País"
              labelPlacement="outside"
              placeholder=" "
              variant="bordered"
              radius="sm"
              classNames={{ label: 'font-semibold' }}
              disallowEmptySelection={true}
              selectedKeys={(!!form.country_id && !!countries.length) ? [form.country_id] : []}
              onSelectionChange={v => onChange(v.currentKey, 'country_id')}
            >
              {countries.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </Select>
          </div>

          <Divider />

          <div className="grid grid-cols-3 gap-4 px-6">

            <Select
              label="Año escolar"
              labelPlacement="outside"
              placeholder=" "
              variant="bordered"
              radius="sm"
              classNames={{ label: 'font-semibold' }}
              selectedKeys={!!form.school_year_id ? [form.school_year_id] : []}
              onSelectionChange={v => onChange(v.currentKey, 'school_year_id')}
            >
              {schoolYears.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </Select>

            <Select
              label="Grado"
              labelPlacement="outside"
              placeholder=" "
              variant="bordered"
              radius="sm"
              classNames={{ label: 'font-semibold' }}
              selectedKeys={!!form.school_grade_id ? [form.school_grade_id] : []}
              onSelectionChange={v => onChange(v.currentKey, 'school_grade_id')}
            >
              {grades.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </Select>


            <Select
              label="Materia"
              labelPlacement="outside"
              placeholder=" "
              variant="bordered"
              radius="sm"
              classNames={{ label: 'font-semibold' }}
              selectedKeys={!!form.subject_id ? [form.subject_id] : []}
              onSelectionChange={v => onChange(v.currentKey, 'subject_id')}
            >
              {subjects.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </Select>

          </div>

          <div className="flex gap-2 flex-wrap items-center">
            {subjectsSelected?.map((item, index) => {
              return (
                <div key={item.id} className='w-full'>
                  <div className='bg-primary text-white p-2 px-6 flex justify-between items-center'>
                    <p className='capitalize'>{item.name}</p>
                    <p className='cursor-pointer' onClick={() => onRemoveGrade(item.id)}>Borrar grado</p>
                  </div>
                  {
                    item.subjects.map((subject) => (
                      <div className='flex justify-between gap-2 px-6 py-1' key={subject.id}>
                        <p className='capitalize'>{subject.name}</p>
                        <Tooltip content="Eliminar" color="danger">
                          <IconTrash className='cursor-pointer' onClick={() => onRemoveSubject(subject.id)} />
                        </Tooltip>
                      </div>
                    ))
                  }
                </div>
              )
            })}
          </div>

          <Divider />

          <div className="grid grid-cols-3 gap-4 px-6">
            <Input
              label="Contraseña"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              type={isVisible ? "text" : "password"}
              value={form.password}
              onValueChange={v => onChange(v, 'password')}
              endContent={visibilityBtn}
            />
            <Input
              label="Confirmar contraseña"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              type={isVisible ? "text" : "password"}
              value={form.confirm_password}
              onValueChange={v => onChange(v, 'confirm_password')}
              endContent={visibilityBtn}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cerrar</Button>
        <Button className="bg-green" color="primary" onPress={submit}>Guardar</Button>
      </ModalFooter>
    </>
  )
}

const useForm = (item) => {


  const initialForm = {
    id: null,
    author_id: null,
    photo: {},
    photoUrl: '',
    name: '',
    lastname: '',
    level_id: Constants.USER.LEVELS.PROFESSOR,
    document_type_id: '',
    document: '',
    school_grade_id: '',
    school_year_id: '',
    subject_id: '',
    phonecode_id: '',
    phone: '',
    email: '',
    country_id: '',
    password: '',
    confirm_password: '',
    hasFile: true,
  };

  const user = useSelector(state => state.user);
  const [form, setForm] = useState(initialForm);
  const [dniTypes, setDniTypes] = useState([]);
  const [phoneCodes, setPhoneCodes] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [countries, setCountries] = useState([]);
  const [grades, setGrades] = useState([]);
  const [schoolYears, setSchoolYears] = useState([]);
  const [subjectsSelected, setSubjectsSelected] = useState([]);

  const onChange = (value, target) => {
    if (target === 'photo' && !!value) {
      setForm(s => ({
        ...s,
        photoUrl: URL.createObjectURL(value),
      }));
    }

    if (target === 'subject_id') {
      const findSubject = subjects.find(x => x.value === value);
      addSubjectSelected(findSubject);
    }

    setForm(s => ({ ...s, [target]: value }));
  };

  const onError = (msg) => {
    toast.error(msg);
    return false;
  }

  const addSubjectSelected = (subject) => {
    if (!subject) return;
    const grade = grades.find(x => x.id === subject.school_grade_id);
    if (!grade) return;

    setSubjectsSelected(prevSubjects => {
      const updatedSubjects = [...prevSubjects ?? []];
      const existingGrade = updatedSubjects.find(g => g.id === grade.id);
      if (existingGrade) {

        const isAlreadyAdded = existingGrade.subjects.some(sub => sub.id === subject.id);
        if (!isAlreadyAdded) {
          existingGrade.subjects.push({
            id: subject.id,
            name: subject.name,
          });
        }
      } else {
        updatedSubjects.push({
          id: grade.id,
          name: grade.name,
          subjects: [
            {
              id: subject.id,
              name: subject.name,
            },
          ],
        });
      }
      return updatedSubjects;
    })
  }

  const onRemoveGrade = (gradeId) => {
    setSubjectsSelected(subjectsSelected.filter(s => s.id !== gradeId))
  }

  const onRemoveSubject = (subjectId) => {
    setSubjectsSelected(subjectsSelected.map(s => {
      if (s.subjects.some(sub => sub.id === subjectId)) {
        return {
          ...s,
          subjects: s.subjects.filter(sub => sub.id !== subjectId),
        };
      }
      return s;
    }))
  }

  const isValidForm = () => {
    if (!form.name)
      return onError('Debe indicar el nombre');

    if (!form.lastname)
      return onError('Debe indicar el apellido');

    if (!form.document_type_id)
      return onError('Debe indicar el tipo de documento');

    if (!form.document)
      return onError('Debe indicar el número de cédula');

    if (!form.phonecode_id)
      return onError('Debe indicar el código de área');

    if (!form.phone)
      return onError('Debe indicar el número telefónico');

    if (!form.email)
      return onError('Debe indicar el correo');

    if (!subjectsSelected.length)
      return onError('Debe indicar al menos una materia');

    if (!form.id && !form.password)
      return onError('Debe indicar la contraseña');

    if (form.password !== form.confirm_password)
      return onError('Las contraseñas no coinciden');

    return true;
  }

  const onSubmit = async () => {
    if (!isValidForm()) return;

    const isEditing = !!form.id;
    const data = {
      ...form,
      school_id: user.id,
      school_year_id: +form.school_year_id,
      subjects: subjectsSelected.flatMap(s => s.subjects.map(sub => sub.id)),
    };

    try {
      isEditing
        ? await UsersService.school.update(data)
        : await UsersService.school.create(data)
      toast.success(`Usuario ${isEditing ? 'actualizado' : 'creado'} correctamente`);
      return true;

    } catch (error) {
      onError(String(error));
      return false;
    }
  }

  const getSelects = async () => {
    const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));

    try {
      const selects = await UsersService.school.getSelects({ user_id: user.id });
      setDniTypes(toSelect(selects.document_types));
      setPhoneCodes(toSelect(selects.phonecodes));
      setCountries(toSelect(selects.countries));
      setGrades(toSelect(selects.school_grades));
      setSchoolYears(toSelect(selects.school_years));
      setSubjects(toSelect(selects.subjects));

    } catch (error) {
      onError(String(error));
      return false;
    }
  }

  const getSubjects = async () => {
    const subjects = await SchoolService.schoolAdmin.getSubjects({
      school_id: user.id,
      professor_id: item.id,
      perPage: 99,
      school_year_id: +form.school_year_id,
    });
    setSubjectsSelected(subjects.data)
  }

  useEffect(() => {
    getSelects();

    if (!!item) {
      setForm({
        ...form,
        id: item?.id,
        photoUrl: !!item?.photo ? fromPhotos(item.photo) : '',
        name: item?.name,
        lastname: item?.lastname,
        document_type_id: String(item?.document_type_id || ''),
        document: item?.document,
        phonecode_id: String(item?.phonecode_id || ''),
        phone: item?.phone,
        email: item?.email,
        country_id: String(item?.country_id || ''),
      });
    }
  }, []);


  useEffect(() => {
    // Colocar el ultimo año escolar creado por defecto
    if (!schoolYears.length) return;
    setForm(s => ({
      ...s,
      school_year_id: schoolYears[schoolYears.length - 1].value,
    }));
  }, [schoolYears])


  // Obtener materia del profesor
  useEffect(() => {
    if (!item || !form.school_year_id) return;
    getSubjects();
  }, [item, form.school_year_id])

  return {
    countries,
    dniTypes,
    form,
    onChange,
    onSubmit,
    phoneCodes,
    subjects: subjects.filter(x => x.school_grade_id === +form.school_grade_id),
    grades: grades.filter(x => x.school_year_id === +form.school_year_id),
    subjectsSelected,
    onRemoveGrade,
    onRemoveSubject,
    schoolYears,
  }
}

export default ModalCreateTeacher;
